import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { IconButton, Collapse, Card, CardHeader } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import { Grid, Label } from 'semantic-ui-react'
import { Table, TableBody, TableRow, TableHead, TableCell, TableContainer, Paper } from '@material-ui/core'
import { stringToFunction } from 'core/utilities'
import { PreQContainer } from './styled'
import { preQAttribute as pqa } from '../../attributeData'
import { getBusinessPartners } from 'ducks/options'
import { getPreQFormulas } from 'ducks/shortList'
import r from 'reactotron-react-js'

const PreQualification = (props) => {
  const { valueForm, change, isDisplay = false, businessPartners, preQFormulas, showCollapse = true } = props
  const [showPreQInfo, setShowPreQInfo] = useState(true)

  useEffect(() => {
    if (!businessPartners.data.length && !businessPartners.loading) {
      props.getBusinessPartners()
    }

    if (!preQFormulas.data.length && !preQFormulas.loading) {
      props.getPreQFormulas()
    }
  }, [])

  useEffect(() => {
    calculateScore()
  }, [valueForm.pqs])

  var docYear = (valueForm.documentDate || new Date()).getFullYear()
  docYear = docYear < 2500 ? docYear + 543 : docYear
  const docYears = [docYear - 1, docYear - 2, docYear - 3, docYear - 4, docYear - 5]

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return !isDisplay
    }
  }

  const vendorDataEditable = (index) => {
    return editableForm() && valueForm.pqs && valueForm.pqs[index] ? true : false
  }

  const vendorLength = () => {
    var vl = valueForm && valueForm.pqs ? (valueForm.pqs || []).length : 0

    return vl > 3 ? vl : 3
  }

  const renderVendorName = () => {
    var elements = [
      <TableCell rowSpan={2} variant='head' style={{ fontWeight: 'bold' }}>Company Profile</TableCell>,
      <TableCell rowSpan={2} variant='head' style={{ fontWeight: 'bold' }}>เกณฑ์คะแนน</TableCell>
    ]

    var elements2 = []

    for (let index = 0; index < vendorLength(); index++) {
      const vendorCode = valueForm.pqs && valueForm.pqs[index] ? valueForm.pqs[index].vendorCode || '' : ''
      const vendor = businessPartners.data.find(v => v.value === vendorCode)
      const vendorName = (vendor ? vendor.text : '').replace(`${vendorCode} : `, '')

      elements.push(
        <TableCell colSpan={2} style={{ fontWeight: 'bold', verticalAlign: 'top', borderLeft: 'solid 1.5px #999' }}>
          <Grid columns='equal' style={{ marginBottom: 'unset' }}>
            <Grid.Row style={{ paddingBottom: vendorName ? '5px' : '' }}>
              <Grid.Column floated='left'>{`Vendor ${index + 1}`}</Grid.Column>
            </Grid.Row>
            {vendorName ? <Grid.Row style={{ paddingTop: '0px' }}><Grid.Column>{vendorName}</Grid.Column></Grid.Row> : null}
          </Grid>
        </TableCell>
      )

      elements2.push(
        <TableCell style={{ fontWeight: 'bold', verticalAlign: 'top', borderLeft: 'solid 1.5px #999' }}>ข้อมูล</TableCell>
      )

      elements2.push(
        <TableCell style={{ fontWeight: 'bold', verticalAlign: 'top' }}>คะแนน</TableCell>
      )
    }

    var result = [<TableRow>{elements}</TableRow>, <TableRow>{elements2}</TableRow>]

    return result
  }

  const renderYearEstablished = () => {
    var elements = [
      <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.yearEstablished.title}</TableCell>,
      <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.yearEstablished.maxScore}</TableCell>
    ]

    for (let index = 0; index < vendorLength(); index++) {
      elements.push(renderNumberField(`pqs[${index}].numberOfYearEstablished`, index, pqa.yearEstablished.formula, `pqs[${index}].numberOfYearEstablishedScore`))
      elements.push(renderScoreField(`pqs[${index}].numberOfYearEstablishedScore`, index))
    }

    return (<TableRow>{elements}</TableRow>)
  }

  const renderBankLoan = () => {
    var elements = [
      <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.bankLoan.title}</TableCell>,
      <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.bankLoan.maxScore}</TableCell>
    ]

    for (let index = 0; index < vendorLength(); index++) {
      elements.push(renderNumberField(`pqs[${index}].bankLoan`, index, pqa.bankLoan.formula, `pqs[${index}].bankLoanScore`))
      elements.push(renderScoreField(`pqs[${index}].bankLoanScore`, index))
    }

    return (<TableRow>{elements}</TableRow>)
  }

  const renderRegisteredCapital = () => {
    var elements = [
      <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.registeredCapital.title}</TableCell>,
      <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.registeredCapital.maxScore}</TableCell>
    ]
    for (let index = 0; index < vendorLength(); index++) {
      elements.push(renderNumberField(`pqs[${index}].registeredCapital`, index, pqa.registeredCapital.formula, `pqs[${index}].registeredCapitalScore`))
      elements.push(renderScoreField(`pqs[${index}].registeredCapitalScore`, index))
    }

    return (<TableRow>{elements}</TableRow>)
  }

  const renderPaidUpCapital = () => {
    var elements = [
      <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.paidUpCapital.title}</TableCell>,
      <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.paidUpCapital.maxScore}</TableCell>
    ]
    for (let index = 0; index < vendorLength(); index++) {
      elements.push(renderNumberField(`pqs[${index}].paidUpCapital`, index, pqa.paidUpCapital.formula, `pqs[${index}].paidUpCapitalScore`))
      elements.push(renderScoreField(`pqs[${index}].paidUpCapitalScore`, index))
    }

    return (<TableRow>{elements}</TableRow>)
  }

  const renderIncome = () => {
    var result = [<TableRow><TableCell variant='head' colSpan={`${(vendorLength() * 2) + 2}`} style={{ fontWeight: 'bold' }}>{pqa.incomes.title}</TableCell></TableRow>]

    docYears.forEach((year, yearIndex) => {
      var elements = []
      for (let index = 0; index < vendorLength(); index++) {
        if (index === 0) {
          elements = [
            <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{year}</TableCell>,
            <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.incomes.maxScore}</TableCell>
          ]
        }
        elements.push(renderNumberField(`pqs[${index}].incomes[${yearIndex}].value`, index, pqa.incomes.formula, `pqs[${index}].incomes[${yearIndex}].score`))
        elements.push(renderScoreField(`pqs[${index}].incomes[${yearIndex}].score`, index))
      }

      result.push(<TableRow>{elements}</TableRow>)
    })

    return result
  }

  const renderCapitalRatio = () => {
    var result = [<TableRow><TableCell variant='head' colSpan={`${(vendorLength() * 2) + 2}`} style={{ fontWeight: 'bold' }}>{pqa.capitalRatio.title}</TableCell></TableRow>]

    docYears.forEach((year, yearIndex) => {
      var elements = []
      for (let index = 0; index < vendorLength(); index++) {
        if (index === 0) {
          elements = [
            <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{year}</TableCell>,
            <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.capitalRatio.maxScore}</TableCell>
          ]
        }
        elements.push(renderNumberField(`pqs[${index}].capitalRatios[${yearIndex}].value`, index, pqa.capitalRatio.formula, `pqs[${index}].capitalRatios[${yearIndex}].score`))
        elements.push(renderScoreField(`pqs[${index}].capitalRatios[${yearIndex}].score`, index))
      }

      result.push(<TableRow>{elements}</TableRow>)
    })

    return result
  }

  const renderProfit = () => {
    var result = [<TableRow><TableCell variant='head' colSpan={`${(vendorLength() * 2) + 2}`} style={{ fontWeight: 'bold' }}>{pqa.profits.title}</TableCell></TableRow>]

    docYears.forEach((year, yearIndex) => {
      var elements = []
      for (let index = 0; index < vendorLength(); index++) {
        if (index === 0) {
          elements = [
            <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{year}</TableCell>,
            <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.profits.maxScore}</TableCell>
          ]
        }
        elements.push(renderNumberField(`pqs[${index}].profits[${yearIndex}].value`, index, pqa.profits.formula, `pqs[${index}].profits[${yearIndex}].score`))
        elements.push(renderScoreField(`pqs[${index}].profits[${yearIndex}].score`, index))
      }

      result.push(<TableRow>{elements}</TableRow>)
    })

    return result
  }

  const renderShareholder = () => {
    var result = [<TableRow><TableCell variant='head' colSpan={`${(vendorLength() * 2) + 2}`} style={{ fontWeight: 'bold' }}>{pqa.shareholders.title}</TableCell></TableRow>]

    docYears.forEach((year, yearIndex) => {
      var elements = []
      for (let index = 0; index < vendorLength(); index++) {
        if (index === 0) {
          elements = [
            <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{year}</TableCell>,
            <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.shareholders.maxScore}</TableCell>
          ]
        }
        elements.push(renderNumberField(`pqs[${index}].shareholders[${yearIndex}].value`, index, pqa.shareholders.formula, `pqs[${index}].shareholders[${yearIndex}].score`))
        elements.push(renderScoreField(`pqs[${index}].shareholders[${yearIndex}].score`, index))
      }

      result.push(<TableRow>{elements}</TableRow>)
    })

    return result
  }

  const renderSummary = () => {

    return (
      <React.Fragment>
        <TableRow>
          <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.summary.score.title}</TableCell>
          <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.summary.score.value}</TableCell>
          {
            (valueForm.pqs || []).map((pq, index) => 
              <TableCell colSpan={2} style={{ fontWeight: 'bold', textAlign: 'right' }}>{pq.score}</TableCell>
            )
          }
        </TableRow>
        <TableRow>
          <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.summary.percentage.title}</TableCell>
          <TableCell variant='head' width={2} style={{ fontWeight: 'bold' }}>{pqa.summary.percentage.value}</TableCell>
          {
            (valueForm.pqs || []).map((pq, index) => 
              <TableCell colSpan={2} style={{ fontWeight: 'bold', textAlign: 'right' }}>{pq.percentage}%</TableCell>
            )
          }
        </TableRow>
        <TableRow>
          <TableCell variant='head' colSpan={2} style={{ fontWeight: 'bold' }}>{pqa.summary.result.title}</TableCell>
          {
            (valueForm.pqs || []).map((pq, index) => 
              <TableCell colSpan={2} style={{ fontWeight: 'bold', textAlign: 'right' }}>
                <Label color={Number(pq.percentage) >= 70 ? 'green' : 'gray'}>ผ่าน</Label>
                <Label color={Number(pq.percentage) >= 70 ? 'gray' : 'red'}>ไม่ผ่าน</Label>
              </TableCell>
            )
          }
        </TableRow>
        
      </React.Fragment>
    )
  }

  const renderNumberField = (name, index, formulaName, scoreFieldName) => {
    return (
      <TableCell style={{ borderLeft: 'solid 1.5px #999' }}>
        <Field
          name={name}
          editable={vendorDataEditable(index)}
          containerStyle={{ margin: '0px' }}
          specialOnChange={(value) => calculateScore(formulaName, value, scoreFieldName)}
          style={{ margin: '0px' }}
          type={type.number}
          component={FieldInput}
        />
      </TableCell>
    )
  }

  const renderScoreField = (name, index) => {
    return (
      <TableCell>
        <Field
          name={name}
          editable={false}
          containerStyle={{ margin: '0px', width: '50px' }}
          style={{ margin: '0px' }}
          type={type.number}
          component={FieldInput}
        />
      </TableCell>
    )
  }

  const calculateScore = (formulaName, value, fieldName) => {
    var result = 0
    var formula = preQFormulas.data.find(f => f.name === formulaName)
    
    if (formula) {
      var fn = stringToFunction(formula.formula)
      if (fn) {
        result = fn(value)
      }
    }

    change(fieldName, result)
    calculateSummary()
  }

  const calculateSummary = () => {
    valueForm.pqs.forEach((pq, index) => {
      var totalScore = 0
      totalScore += Number(pq.numberOfYearEstablishedScore)
      totalScore += Number(pq.bankLoanScore)
      totalScore += Number(pq.registeredCapitalScore)
      totalScore += Number(pq.paidUpCapitalScore)
      pq.incomes && pq.incomes.forEach(x => { totalScore += Number(x.score) })
      pq.capitalRatios && pq.capitalRatios.forEach(x => { totalScore += Number(x.score) })
      pq.profits && pq.profits.forEach(x => { totalScore += Number(x.score) })
      pq.shareholders && pq.shareholders.forEach(x => { totalScore += Number(x.score) })

      var percentage = (totalScore / pqa.summary.score.value) * 100

      change(`pqs[${index}].score`, totalScore)
      change(`pqs[${index}].percentage`, percentage.toFixed(2))
    })
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='Pre-Q Part A'
        action={
          showCollapse ?
            <IconButton aria-label='Expand' onClick={() => setShowPreQInfo(!showPreQInfo) }>
              {showPreQInfo ? <ExpandLess /> : <ExpandMore />}
            </IconButton> : null
        }
      />
      <Collapse in={showPreQInfo}>
        <PreQContainer>
          <TableContainer style={{ marginTop: '10px', border: 'solid 1px #C5C5C5', borderRadius: '5px' }} component={Paper}>
            <Table>
              <TableHead>
                {renderVendorName()}
              </TableHead>
              <TableBody>
                {renderYearEstablished()}
                {renderBankLoan()}
                {renderRegisteredCapital()}
                {renderPaidUpCapital()}
                {renderIncome()}
                {renderCapitalRatio()}
                {renderProfit()}
                {renderShareholder()}
                {renderSummary()}
              </TableBody>
            </Table>
          </TableContainer>
        </PreQContainer>
      </Collapse>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return ({
    businessPartners: state.options.businessPartners,
    preQFormulas: state.shortList.preQFormulas,
  })
}

const mapDispatchToProps = {
  getBusinessPartners,
  getPreQFormulas
}

export default connect(mapStateToProps, mapDispatchToProps)(PreQualification)